import { ILocalizationItem } from "@multiweb/types/contracts";

/**
 * Vytvoří lokalizační položku se zadanými daty.
 * @param locKey Lokalizační klíč.
 * @param primaryText Text překladu.
 * @param secondaryText Podrobný text překladu.
 */
const createLocalizationItem = (locKey: string, primaryText: string, secondaryText?: string): ILocalizationItem => ({
    language: "MOCK_LANG",
    locKey,
    primaryText,
    secondaryText,
});

/**
 * Vytvoří lokalizační mapu na základě zadaných dat. Tu je pak možné použít pro naplnění stavu i18n modulu
 * pomocí akce z bridge modulu createLocalizationLoadedAction.
 *
 * Slouží primárně pro testy v i18n a bridge modulu. Pro ostatní případy by měly být dostačující prostředky popsané
 * ve Storybooku (https://teaf.tescosw.cz/mw/storybook/?path=/story/dokumentace-moduly-core-i18n--použití).
 *
 * @param localizationDefinition Objekt s definicí překladů. Například:
 * {
 * "GUI-123": {primaryText: "Přeložený text", secondaryText: "Detailní popis"},
 * "GUI-345": {primaryText: "Jiný přeložený text"},
 * }
 */
export const createLocalizationMap = (localizationDefinition: {[key: string]: {primaryText: string; secondaryText?: string}}): ReadonlyMap<string, ILocalizationItem> => {
    return new Map(
        Object.keys(localizationDefinition).map((locKey) => [
            locKey,
            createLocalizationItem(
                locKey,
                localizationDefinition[locKey].primaryText,
                localizationDefinition[locKey].secondaryText,
            ),
        ]),
    );
};
